import React, { useState } from 'react'
import { useHttp } from '../hooks/http.hook'
import { Toaster } from './components/Toaster'
import { useParams } from 'react-router';

//import { Row } from 'react-bootstrap'; // { Button, Form, Row, Col, Table } 
//import { FaTrashAlt, FaSave, FaExternalLinkAlt } from 'react-icons/fa';

import './css/ContentPages.css';

export const ChangePasswordPage = () => {
    const { request, error, loading } = useHttp()
    const [receivedError, setReceivedError] = useState(error)

    const [changed, setChanged] = useState(false)
    const [form, setForm] = useState({ newPassword: '', confirmPassword: '' })

    const { ticket } = useParams();

    const changeHandler = event => {
        setForm({ ...form, [event.target.name]: event.target.value })
    }

    const sendChanges = async () => {
        if (!ticket) {
            setReceivedError('ticket not found');
            return;
        }

        try {
            const data = await request(`/user/change-password`, 'POST', {
                newPassword: form.newPassword, confirmPassword: form.confirmPassword, ticket
            });

            if (data?.result)
                setChanged(true);

        } catch (e) {
            setReceivedError(e)
        }
    }


    return (
        <>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}

            <h3 className="FormTitle">Set New User Password</h3>

            {changed ? <div><p className="text-white text-bold">Password changed</p><span className='text-white'>You can use it in mobile app</span></div> :

                <form className="FormBlocks">
                    <input className="InputBlock" type="password" name="newPassword" placeholder="New Password" value={form.newPassword}
                        onChange={changeHandler} autoComplete='new-password' />

                    <input className="InputBlock" type="password" name="confirmPassword" placeholder="Confirm Password" value={form.confirmPassword}
                        onChange={changeHandler} autoComplete='confirm-password' />

                    <button className={`ButtonBlock ${loading && "ButtonBlockDisabled"}`}
                        variant="primary" type="submit" disabled={loading}
                        onClick={sendChanges}>
                        Change
                    </button>
                </form>

            }
        </>
    )
}
